export default "__VITE_ASSET__B07uNt3R__"